import React from 'react'
import PropTypes from 'prop-types'
import formatCatalogueNumber from '../../helpers/formatCatalogueNumber'
import * as Styled from './Name.styles'
import { useFeatureFlagContext } from '../../providers/FeatureFlagContext/FeatureFlagContext'

const Name = ({ productName, excludedFromMoneyBack, catNumber }) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()

  return (
    <Styled.ProductName pdpV2={PDP_V2_FLAG} data-test='product-name'>
      <Styled.Main pdpV2={PDP_V2_FLAG} className={!PDP_V2_FLAG ? 'h2' : ''} data-test='product-name-main'>
        <span itemProp='name' data-test='product-title' data-youreko='product-title'>
          {productName}
        </span>
      </Styled.Main>
      {catNumber && (
        <Styled.CatNumber data-test='product-name-catNumber' itemProp='sku' content={catNumber}>
          {formatCatalogueNumber(catNumber)}
        </Styled.CatNumber>
      )}
      {excludedFromMoneyBack && <sup>&dagger;</sup>}
    </Styled.ProductName>
  )
}

Name.propTypes = {
  productName: PropTypes.string,
  catNumber: PropTypes.string,
  excludedFromMoneyBack: PropTypes.bool
}

export default Name
